import { HStack, InputProps, TextProps } from '@chakra-ui/react';
import { CancelIcon, LockIcon, VisibilityIcon, VisibilityOffIcon } from 'assets/icons/v2';
import { FormInput } from 'components/ui/form/Input';
import { NovaIcon } from 'components/ui/novaIcon';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import React, { ReactElement, useMemo, useState } from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

type Props = InputProps & {
  placeholder: string;
  label?: string;
  labelPosition?: TextProps['textAlign'];
  error: FieldError;
  value: string;
  labelMarginBottom?: string;
  register: () => UseFormRegisterReturn<string>;
  reset: () => void;
};

export const PasswordInputField = ({
  label,
  labelPosition = 'left',
  placeholder,
  error,
  value,
  register,
  reset,
  ...props
}: Props): ReactElement => {
  const [shouldShowPassword, setShouldShowPassword] = useState(false);

  const InputIcons = useMemo((): ReactElement => {
    return (
      <HStack gap="5px" width="auto">
        <NovaIconButton
          tabIndex={-1}
          aria-label="Passwort anzeigen oder verbergen"
          variant="primary"
          size="s"
          onClick={() => setShouldShowPassword(!shouldShowPassword)}
          color="icon.tertiary"
          icon={shouldShowPassword ? VisibilityOffIcon : VisibilityIcon}
        />
        <NovaIconButton
          aria-label="Eingabe löschen"
          variant="primary"
          size="s"
          _focus={{ outline: 'none' }}
          onClick={() => reset()}
          pos="relative"
          color="icon.tertiary"
          className="close-icon"
          icon={CancelIcon}
        />
      </HStack>
    );
  }, [shouldShowPassword, setShouldShowPassword, reset]);

  return (
    <FormInput
      {...props}
      type={shouldShowPassword ? 'text' : 'password'}
      label={label}
      labelPosition={labelPosition}
      placeholder={placeholder}
      error={error}
      registration={register()}
      leftElement={
        <NovaIcon
          icon={LockIcon}
          size="s"
          color={value ? 'icon.accent' : 'icon.quaternary'}
          aria-hidden
        />
      }
      rightElement={value ? InputIcons : undefined}
      flex={1}
      _focus={{ bg: 'background.secondary', borderColor: 'border.accent.active' }}
    />
  );
};
